(() => {
  const mobileQuery = window.matchMedia('(max-width: 640px)');

  const getSplideOptions = (slideCount) => {
    if (mobileQuery.matches) {
      return {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        autoWidth: true,
        gap: 0,
        arrows: true,
        arrowPath: '',
        pagination: false,
        drag: slideCount > 1,
        speed: 600,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        keyboard: 'focused',
        trimSpace: true,
      };
    }

    return {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      autoWidth: false,
      gap: 0,
      arrows: true,
      arrowPath: '',
      pagination: false,
      drag: slideCount > 1,
      speed: 600,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      keyboard: 'focused',
      trimSpace: true,
    };
  };

  const destroySlider = (container) => {
    const splide = container.splide;
    if (!splide) return;

    splide.destroy(true);
    delete container.splide;
  };

  const mountSlider = (container) => {
    if (!window.Splide) return;

    destroySlider(container);

    const sliderElement = container.querySelector('.splide');
    if (!sliderElement) return;

    const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
    if (slideCount === 0) return;

    const splide = new Splide(sliderElement, getSplideOptions(slideCount));
    splide.mount();
    container.splide = splide;
  };

  const syncAll = (scope = document) => {
    scope.querySelectorAll('[data-banner-promo]').forEach(mountSlider);
  };

  document.addEventListener('DOMContentLoaded', () => syncAll());

  document.addEventListener('shopify:section:load', (event) => {
    syncAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-banner-promo]').forEach(destroySlider);
  });

  mobileQuery.addEventListener('change', () => syncAll());
})();
